/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateShouldFullBackupResourceRequest {
  /**
  * Whether should run full backup for the resource in the next run
  */
  'shouldRunFullBackup'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "shouldRunFullBackup",
      "baseName": "shouldRunFullBackup",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateShouldFullBackupResourceRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

